export interface IClinicUserListingModel {
  userId: number;
  clinicId: number;
  storeId: number;
  storeCode: string | undefined;
  scheduledStartDate: string | undefined;
  address: string | undefined;
  marketName: string | undefined;
  joinedDate: string | undefined;
}

export class ClinicUserListingModel implements IClinicUserListingModel {
  userId: number;
  clinicId: number;
  storeId: number;
  storeCode: string | undefined;
  scheduledStartDate: string | undefined;
  address: string | undefined;
  marketName: string | undefined;
  joinedDate: string | undefined;

  constructor(params: Partial<IClinicUserListingModel>) {
    const {
      userId = 0,
      clinicId = 0,
      storeId = 0,
      storeCode = undefined,
      scheduledStartDate = undefined,
      address = undefined,
      marketName = undefined,
      joinedDate = undefined,
    } = params;

    this.userId = userId;
    this.clinicId = clinicId;
    this.storeId = storeId;
    this.storeCode = storeCode;
    this.scheduledStartDate = scheduledStartDate;
    this.address = address;
    this.marketName = marketName;
    this.joinedDate = joinedDate;
  }
}
